

import React, { Component,Suspense } from "react"

import MetaTags from 'react-meta-tags';
import {
  Container,Row,  Col,  Button,  Card,  CardBody,  CardTitle, CardImg, CardHeader,  Modal,  ModalHeader,
  ModalBody,  ModalFooter,  Media,  Table,  Input,  ButtonDropdown,  DropdownToggle,
  DropdownMenu,  DropdownItem,Spinner ,  Dropdown, InputGroup} from "reactstrap"

import Select from "react-select"
import Flatpickr from "react-flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js";

import { MDBDataTable } from "mdbreact"

import "./datatables.scss"

import  { Redirect } from 'react-router-dom'
import "./Accueil.css"
import $ from "jquery"

import url from "../../common/api"
import iconList from "../../common/icon"
import {getLanguageList} from "../../services/langueService.js"
import {getThematiqueList} from "../../services/thematiqueService.js"
import {getFormatList} from "../../services/formatService.js"
import {getUniteAdministrativeList} from "../../services/uniteAdministrativeService.js"
import {getTypeRessourceList,getCardObject,getColorObject} from "../../services/typeRessourceService.js"
import {getTypeSystemeIrrigueList} from "../../services/systemeIrrigueService.js"
import {getMotCleList} from "../../services/motCleService.js"
import {getAuteurList} from "../../services/auteurService.js"
import {getPaysList} from "../../services/paysService.js"
import {getProfileRessource,getRessourceByProfile,getSisDescription,getRessourceBySearch} from "../../services/ressourceService.js"
import {getEvenementBySearch} from "../../services/evenementService.js"
import {getExpertBySearch} from "../../services/expertService.js"
import { getQueries } from "../../queries/getQueries"

import DateRangePicker from 'react-bootstrap-daterangepicker';
import "read-more-less-react/dist/index.css";
import ReadMoreText from "read-more-less-react";

import ShowMoreText from "react-show-more-text";

import ReactSelect from 'react-select'
import makeAnimated from 'react-select/animated';

import { format } from 'date-fns';

// import duplicates from 'find-array-duplicates'

import DetailRessource from './../Ressources/DetailRessource';
import DetailEvenement from './../Evenement/DetailEvenement';
import DetailExpert from './../Experts/DetailExpert';

//Icones sis
import iconesis from "../../assets/images/icone-sis/autre.png"
import img_acceuil from "../../assets/images/icone-sis/imgIntro2.jpg"


class Acceuil extends Component {
  constructor(props) {
    super(props)
    this.state = {
      default: "",
      half: "",
      customize: "",
      ok:"",
      sis_description:"",
      chargement:false,
      ressourceData:[],
      evenementData:[],
      expertData:[],
      expert:[],
      modal: false,
      subscribemodal: false,
      ressource:[],
      evenements:[],
      irrigue:[],
      langue:[],
      auteur:[],
      thematique:[],
      motcle:[],
      type_ressource:[],
      sous_type_ressource:[],
      format:[],
      unite:[],
      localisation:[],
      ressource_type_ressource:[],
      ressource_type_ressource_last:[],
      ressource_motcle:[],
      ressource_format:[],
      ressource_unite:[],
      ressource_irrigation:[],
      ressource_langue:[],
      ressource_thematique:[],
      ressource_localisation:[],
      expert_thematique:[],
      expert_langue:[],
      expert_pays:[],
      expert_systeme_irrigue:[],
      expert_unite:[],
      evenement_thematique:[],
      evenement_langue:[],
      evenement_pays:[],
      evenement_systeme_irrigue:[],
      evenement_unite:[],
      evenement_mot:[],
      ressource_date:[],
      ressource_auteur:[],
      data_card:{},
      icons:{},
      array_filter:{},
      data_sous_card:{},
      data_card_default:{},
      data_card_init:{},
      color_card:{"TOUTES":"#032e87"},
      color_sous_card:{},
      color_card_init:{},
      color_toute:"",
      date_choose:false,
      filtre:[],
      select_type:0,
      select_localisation:0,
      select_langue:0,
      select_thematique:0,
      date_interval_check:true,
      thematique_choose:false,
      langue_choose:false,
      localisation_choose:false,
      auteur_choose:false,
      irrigation_choose:false,
      unite_choose:false,
      format_choose:false,
      type_ressource_choose:false,
      motcle_choose:false,
      recherche:true,
      recherche_card:true,
      block_card:null,
      block_detail:"",
      show_detail:false,
      entriesLabelList: ["5", "10", "20", "50", "100"],
      block_ressource:<div style={{textAlign:"center"}}>
      <Spinner size="md" color="secondary" />,
      </div>,
    block_init_page:<div style={{marginTop:"250px",textAlign:"center"}}>
    <Spinner type="grow" color="secondary" /></div>,
     color:"",
     color_sous_ressource_card:"",
     type_ressource_card:"TOUTES",
     type_sous_ressource_card:"",
     card_exist:false,
     sous_card_exist:false
     

    }
    this.handleDetail.bind(this)
    this.togglemodal.bind(this)
    this.togglesubscribemodal.bind(this)
    this.handleRechercheSimple.bind(this)
    this.handleFiltreAvance.bind(this)
    this.handleFiltreAvanceLangue.bind(this)
    this.handleFiltreAvanceType.bind(this)
    this.handleFiltreAvanceThematique.bind(this)
    this.handleFiltreAvanceLocalisation.bind(this)
    this.handleFiltreAvanceMotCle.bind(this)
    this.handleFiltreAvanceFormat.bind(this)
    this.handleFiltreAvanceUnite.bind(this)
    this.handleFiltreAvanceAuteur.bind(this)
    this.handleFiltreAvanceTypeRessource.bind(this)
    this.handleDateInterval.bind(this)
    this.handleDetailEvent.bind(this)
    this.handleDetailExpert.bind(this)
    this.handleChargerData.bind(this)
    this.handleShowRessourceCard.bind(this)
    this.handleTraiteRessourceCard.bind(this)
    this.handleFiltreAvanceSousTypeRessource.bind(this)
    this.handlePushSousType.bind(this)
    this.handleShowAllExpert.bind(this)
    this.handleRefresh.bind(this)
    this.handleRefreshEvent.bind(this)
    this.handleRefreshExpert.bind(this)
      
  }



  componentDidMount() {
    $("input[placeholder=\"Chercher\"]").hide()
    var icons={}
    
    $('#acceuil-link').show()
  
    getTypeRessourceList().then(e=>{
      this.setState({type_ressource:e})
       e.map((val,idx)=>{
        icons[val.label]=iconList[val.icon]?iconList[val.icon]:iconList.AUTRE_ICO
         this.setState({icons:icons})
        
       })
    })

    getSisDescription().then(e=>{
      this.setState({sis_description:e[0]?.description})
    })

     //check data
     const public_id=JSON.parse(sessionStorage.getItem("authPublic"))?.profile?.id
     const private_id=JSON.parse(sessionStorage.getItem("authAshia"))?.profile?.id
     console.log("prof",private_id)
     if(private_id){
      //sessionStorage.setItem("public_id", JSON.stringify(data[0]))
      this.handleChargerData(private_id,true)
     }else{
       if(public_id){
        localStorage.setItem("private_id", public_id)
        console.log("public exist")
        this.handleChargerData(public_id,false)
        sessionStorage.removeItem("profileAuthAshia")
       }else{
        console.log("public not  exist")

        getQueries("profile/public").then(data=>{
          localStorage.setItem("private_id", data.id)
          sessionStorage.setItem("authPublic", JSON.stringify(data))
          this.handleChargerData(data?.id,false)
        })
        sessionStorage.removeItem("profileAuthAshia")

       }
     
     }
    
     

     getCardObject().then(e=>this.setState({data_card_init:e}))


  
  }



  handleChargerData=(id,private_user)=>{

    getProfileRessource(id).then(data=>{
    // getRessourceByProfile({profile_id:data.id}).then(data=>{

    if(private_user){
      sessionStorage.setItem("profileAuthAshia", JSON.stringify(data))
    }
    

    this.setState({ressourceData:data.ressources,chargement:true})
    var event={}
    var card={}
    console.log("ress",data)
    
   
      var ressource=[]
      
      data.ressources.map((element,idx) =>{
        this.setState({card_exist:true})

        const description=element.description.substr(0,300)


        try{
          card[""+element.type_ressource.libelle].push(element)
          this.setState({data_card:card,data_card_default:card})
        }catch(error){
          card[""+element.type_ressource.libelle]=[]
          card[""+element.type_ressource.libelle].push(element)

          this.setState({data_card:card,data_card_default:card})
        }
        
        var tab= {
          id: element.id,
          key:element.id,
          nom: element.nom,

          description:element.description.length>=300?description+" ...":description,
          statut: element.statut,

          nombredevue : 
          <div
            data-toggle="tooltip" 
            data-placement="top" 
            data-html="true"
            title="Nombre de consultations de la ressource"
          >
            <span style={{backgroundColor:"#6A7172",color:"white"}} className="badge rounded-pill ">{element.nombre_vue}</span>
          </div>,

         nombredetelechargement : 
          <div
            data-toggle="tooltip" 
            data-placement="top" 
            data-html="true"
            title="Nombre de téléchargements de la ressource"
          >
            <span style={{backgroundColor:"#6A7172"}} className="badge rounded-pill ">{element.nombre_telecharge}</span>
          </div>,

          action: <span style={{backgroundColor:"#5FC4E1"}} className="badge rounded-pill"> <a key={idx} onClick={this.handleDetail.bind(this.bind,element.id)} >Consulter</a></span>,
          //  action: <a > <i key={idx} onClick={this.handleDetail.bind(this.bind,element.id)} style={{color:"#5FC4E1"}} className="bx bxs-info-circle bx-sm   "/> </a>,
         
       }
       ressource=[...ressource,tab]
       
        
     })
     this.setState({ressource:ressource})
    //  $(".rm-more-button").hide()

    //  $(".rm-more-button").css("color","green")
    //  $(".rm-more-button").css("border","groove 0.1em #6A7172")
    //  $(".rm-more-button").css("border-radius","2em")
    
     
    
     
     
     $(".leFiltre").css("display","none")

    $("#recherche").show()
    $("#data-recherche").hide()
    $('#block_detail_ressource').hide()
    $('#block_page_acceuil').show()
  

  this.handleShowAllEvent(data.evenements)

  this.setState({expertData:data.utilisateurs,evenementData:data.evenements})
  
  this.handleShowAllExpert(data.utilisateurs.filter(e=>e.fonction=="EXPERT"))
    

   })
   
  //  fetch(url+"profiles/"+data.id)
  //     .then((response) => response.json())
  //     .then((data) => {
     
        
  //      }
       
  //     );
  }

  togglemodal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }))
  }

  togglesubscribemodal = () => {
    this.setState(prevState => ({
      subscribemodal: !prevState.subscribemodal,
    }))
  }
  handleDuBouttonRecherche = () => {
    $("#default-recherche").hide()
    $("#charge-recherche-avance").show()
    getLanguageList().then(e=>this.setState({langue:e}))
    getPaysList().then(e=>this.setState({localisation:e}))
    getThematiqueList().then(e=>this.setState({thematique:e}))
    getMotCleList().then(e=>this.setState({motcle:e}))
    getFormatList().then(e=>this.setState({format:e}))
    getTypeSystemeIrrigueList().then(e=>this.setState({irrigue:e}))
    getAuteurList().then(e=>this.setState({auteur:e}))
   
    setTimeout(()=>{
      $("#default-recherche").show()
      $("#charge-recherche-avance").hide()
      $(".leFiltre").css("display","block")
      $(".laRecherche").css("display","none")
      }, 3000);
  
   
  }

  handleDuBouttonFiltre = () => {
    $(".laRecherche").css("display","block")
    $(".leFiltre").css("display","none")
  }

  // handleSelectGroupLocalisation = selectedGroupLocalisation => {
  //   this.setState({ selectedGroupLocalisation })
  // }
  // handleSelectGroupTypeIrrigation = selectedGroupTypeIrrigation => {
  //   this.setState({ selectedGroupTypeIrrigation })
  // }
  // handleSelectGroupLangue = selectedGroupLangue => {
  //   this.setState({ selectedGroupLangue })
  // }
  // handleSelectGroupThematique = selectedGroupThematique => {
  //   this.setState({ selectedGroupThematique })
  // }
  handleAddRessource=()=>{
    this.setState({ok: <Redirect to='/ressource'  />});
  }

  handleDetail=(id)=>{
    this.setState({block_detail:"",show_detail:true})
    const data=this.state.ressourceData.find(val=>val.id===id)
    console.log("******",data)
    sessionStorage.setItem('idressource',id);
    setTimeout(()=>{ 
      this.handleRefresh(data)
    }, 10);
    
    
    
    //this.setState({ok: <Redirect to='/detail-ressource'  />});
  }

  handleRefresh=(data)=>{
    $('#block_page_acceuil').hide()
    this.setState({block_detail:<DetailRessource data={data} index={true} />})
    $('#acceuil-link').hide()
    $('#block_detail_ressource').show()
    
    // this.setState({show_detail:false})
  }
  handleRefreshEvent=()=>{
    this.setState({block_detail:<DetailEvenement index={true} />})
    $('#block_page_acceuil').hide()
    $('#block_detail_ressource').show()
    // this.setState({show_detail:false})
  }

  handleRefreshExpert=()=>{
    this.setState({block_detail:<DetailExpert index={true} />})
    $('#block_page_acceuil').hide()
    $('#block_detail_ressource').show()
    // this.setState({show_detail:false})
  }


  handleDetailEvent=(id)=>{
    this.setState({block_detail:"",show_detail:true})
    sessionStorage.setItem('idEvenement',id);
    //this.setState({ok: <Redirect to='/detail-evenement'  />});

    setTimeout(()=>{ 
      this.handleRefreshEvent()
    }, 1);
  }

  handleDetailExpert=(id)=>{
    this.setState({block_detail:"",show_detail:true})
    sessionStorage.setItem('idExpert',id);

    setTimeout(()=>{ 
      this.handleRefreshExpert()
    }, 10);
  }


  handleRechercheSimple=(e)=>{

      this.setState({ressource:[],card_exist:false,data_card:[],recherche_card:true,block_card: <div style={{textAlign:"center"}}><Spinner size="md" color="secondary" /></div>})
      var data=[]
      var card=[]
      // setTimeout(()=>{
        this.state.ressourceData.filter((data) =>  JSON.stringify(data).toLowerCase().indexOf(e.target.value.toLowerCase()) !== -1).map((element,idx) =>{
          this.setState({card_exist:true})

          const description=element.description.substr(0,300)

          var tab= {
            nom: element.nom,
            //thematique: element.nom,
            description: element.description.length>=300?description+" ...":description,
            //  <ReadMoreText
            //   readMoreText="Voir plus"
            //   readLessText="Voir moins"
            //   lines={5}
            //   text={element.description}
            // />,
            //format: element.format.code,
            //langue: element.nom,
            statut: element.statut,
            //typesystemeirrigue: element.nom,
            nombredevue : 
              <div
                data-toggle="tooltip" 
                data-placement="top" 
                data-html="true"
                title="Nombre de consultations de la ressource"
              >
                <span style={{backgroundColor:"#6A7172",color:"white"}} className="badge rounded-pill ">{element.nombre_vue}</span>
              </div>,

            nombredetelechargement : 
              <div
                data-toggle="tooltip" 
                data-placement="top" 
                data-html="true"
                title="Nombre de téléchargements de la ressource"
              >
                <span style={{backgroundColor:"#6A7172"}} className="badge rounded-pill ">{element.nombre_telecharge}</span>
              </div>,
            action: <span style={{backgroundColor:"#5FC4E1"}} className="badge rounded-pill"> <a key={idx} onClick={this.handleDetail.bind(this.bind,element.id)} >Consulter</a></span>,
            // action: <a > <i onClick={this.handleDetail.bind(this.bind,element.id)} style={{color:"#5FC4E1"}} className="bx bxs-info-circle bx-sm "/> </a>,
            
          }
          try{
            card[""+element.type_ressource.libelle].push(element)
            this.setState({data_card:card})
          }catch(error){
            card[""+element.type_ressource.libelle]=[]
            card[""+element.type_ressource.libelle].push(element)

            this.setState({data_card:card})
          }
          data.push(tab)
          this.setState({ressource:data})
          if(idx==this.state.ressourceData.length-1){
            this.setState({recherche_card:false,block_card:null})
          }
        })
      
        if(e.target.value==""){
          this.setState({ressource:data,data_card:this.state.data_card_default,recherche_card:true,block_card:null})
          const profile_id=JSON.parse(sessionStorage.getItem("authAshia"))?.profile?.id?JSON.parse(sessionStorage.getItem("authAshia"))?.profile?.id:JSON.parse(sessionStorage.getItem("authPublic"))?.profile?.id

          this.handleChargerData(profile_id,false)
        }
        $(".rm-more-button").css("color","green")
        $(".rm-more-button").css("border","groove 0.1em #6A7172")
        $(".rm-more-button").css("border-radius","2em")
  }


handleFiltreAvanceLocalisation = (e) => {
  var unite=[]
  try{
    e.map((element,idx)=>{

      element.unite_administratives.map((el)=>{
        unite=[...unite,{value:el.id,label:el.libelle}]
      
        this.setState({unite:unite})
      })
    })
    var pay_ids=e.map((val)=>val.value)
    this.state.array_filter["pays"]=pay_ids
    this.setState({array_filter:this.state.array_filter})
    
   }catch(ee){
     delete this.state.array_filter["pays"]
     this.setState({array_filter:this.state.array_filter}) 
   }

}

handleFiltreAvanceLangue = (e) => {


  try{
   var langue_ids=e.map((val)=>val.value)
   this.state.array_filter["langue"]=langue_ids
   this.setState({array_filter:this.state.array_filter})
   
  }catch(ee){
    delete this.state.array_filter["langue"]
    this.setState({array_filter:this.state.array_filter}) 
  }

}

handleFiltreAvanceType = (e) => {
  try{
    var system_ids=e.map((val)=>val.value)
    this.state.array_filter["type_systeme_irrigue"]=system_ids
    this.setState({array_filter:this.state.array_filter})
    
   }catch(ee){
     delete this.state.array_filter["type_systeme_irrigue"]
     this.setState({array_filter:this.state.array_filter}) 
   }

}

handleFiltreAvanceThematique = (e) => {
  try{
    var thematique_ids=e.map((val)=>val.value)
    this.state.array_filter["thematique"]=thematique_ids
    this.setState({array_filter:this.state.array_filter})
    
   }catch(ee){
     delete this.state.array_filter["thematique"]
     this.setState({array_filter:this.state.array_filter}) 
   }
 

}

handleFiltreAvanceMotCle=(e)=>{
  try{
    var mot_ids=e.map((val)=>val.value)
    this.state.array_filter["mot_cle"]=mot_ids
    this.setState({array_filter:this.state.array_filter})
    
   }catch(ee){
     delete this.state.array_filter["mot_cle"]
     this.setState({array_filter:this.state.array_filter}) 
   }

}
handleFiltreAvanceFormat=(e)=>{

  try{
    var format_ids=e.map((val)=>val.value)
    this.state.array_filter["format"]=format_ids
    this.setState({array_filter:this.state.array_filter})
    
   }catch(ee){
     delete this.state.array_filter["format"]
     this.setState({array_filter:this.state.array_filter}) 
   }


}
handleFiltreAvanceUnite=(e)=>{

  try{
    var unite_ids=e.map((val)=>val.value)
    this.state.array_filter["unite_administrative"]=unite_ids
    this.setState({array_filter:this.state.array_filter})
    
   }catch(ee){
     delete this.state.array_filter["unite_administrative"]
     this.setState({array_filter:this.state.array_filter}) 
   }


}

handleFiltreAvanceAuteur = (e) => {

  try{
    var auteur_ids=e.map((val)=>val.value)
    this.state.array_filter["auteur"]=auteur_ids
    this.setState({array_filter:this.state.array_filter})
    
   }catch(ee){
     delete this.state.array_filter["auteur"]
     this.setState({array_filter:this.state.array_filter}) 
   }
 

}

handleFiltreAvanceTypeRessource=(e)=>{
  var sous_type=[]
  try{
    var type_ids=e.map((val)=>val.value)

    e.map((element,idx)=>{
  
      element.sous_types.map((el)=>{
        sous_type=[...sous_type,{value:el.id,label:el.libelle}]
        this.setState({sous_type_ressource:sous_type})
      })})


    this.state.array_filter["type_ressource"]=type_ids
    this.setState({array_filter:this.state.array_filter})
    
   }catch(ee){
     delete this.state.array_filter["type_ressource"]
     this.setState({array_filter:this.state.array_filter}) 
   }
 
}

handleFiltreAvanceSousTypeRessource=(e)=>{
  try{
    var sous_type_ids=e.map((val)=>val.value)
    this.state.array_filter["sous_type_ressource"]=sous_type_ids
    this.setState({array_filter:this.state.array_filter})
    
   }catch(ee){
     delete this.state.array_filter["sous_type_ressource"]
     this.setState({array_filter:this.state.array_filter}) 
   }
}



handleFiltreAvance=()=>{
  $("#block").css("background-color","#032e87")

  $("#data-recherche").show()
  $("#recherche").hide()
 
  var id_profile=JSON.parse(sessionStorage.getItem("authAshia"))?.profile?.id
  var filter=this.state.array_filter
  filter["profile_id"]=[id_profile]

  if(localStorage.getItem("private_id") && localStorage.getItem("private_id")!==id_profile){
    filter["profile_id"].push(localStorage.getItem("private_id"))
  }

  this.setState({array_filter:filter})

  try{
    this.state.color_card[""+key]="#032e87"
    this.state.color_card[""+sessionStorage.getItem("prev_color")]=""
  }catch(error){

  }
 

  this.setState({data_card:this.state.data_card_init,data_sous_card:{},type_sous_ressource_card:"",expert:[],card_exist:false})
  this.setState({block_card: <div style={{textAlign:"center"}}><Spinner size="md" color="secondary" /></div>})
  this.setState({recherche_card:false,recherche:false,block_ressource:null,fetchChart:false,spine:"",time_line:""})
  setTimeout(()=>{
    this.handleTraiterRechercher() 
    }, 3000);
    
}
handleShowRessourceCard=(data,key)=>{

  if(key!==sessionStorage.getItem("prev_color")){
    this.state.color_card[""+sessionStorage.getItem("prev_color")]=""
  }
  this.state.color_card["TOUTES"]=""
  this.state.color_card[""+key]="#032e87"

  this.setState({color_sous_card:{},color_card:this.state.color_card,block_init_page:<div style={{marginTop:"250px",textAlign:"center"}}>
  <Spinner type="grow" color="secondary" /></div>,data_sous_card:{}})
  this.setState({color_toute:"",ressource:[],block_ressource:<div style={{textAlign:"center"}}><Spinner size="md" color="secondary" /></div>,recherche:false,block_card:<div style={{textAlign:"center"}}><Spinner size="md" color="secondary" /></div>})
  sessionStorage.setItem('prev_color',key);
  setTimeout(()=>{
    this.handleTraiteRessourceCard(data,key) 
    }, 3000);

    
}

handleShowSousRessourceCard=(data,key)=>{
  if(key!==sessionStorage.getItem("prev_sous_color")){
    this.state.color_sous_card[""+sessionStorage.getItem("prev_sous_color")]=""
  }



  this.state.color_sous_card[""+key]="rgb(3 47 135)"

  this.setState({color_toute:"",ressource:[],recherche:false,color_sous_card:this.state.color_sous_card,block_init_page:<div style={{marginTop:"250px",textAlign:"center"}}>
  <Spinner type="grow" color="secondary" /></div>})
  
  sessionStorage.setItem('prev_sous_color',key);
  setTimeout(()=>{
    this.handleTraiteSousRessourceCard(data,key) 
    }, 1000);

    
}

handleShowAllRessource=()=>{
  this.state.color_card[""+sessionStorage.getItem("prev_color")]=""
  this.state.color_card["tout"]="#032e87"
  this.setState({color_toute:"#032e87",color_sous_card:{},expert:[],data_sous_card:{},color_card:this.state.color_card,type_sous_ressource_card:"",type_sous_ressource_card:""})
  this.setState({block_ressource:<div style={{textAlign:"center"}}><Spinner size="md" color="secondary" /></div>,recherche:false,block_card:<div style={{textAlign:"center"}}><Spinner size="md" color="secondary" /></div>})
  this.handleShowAllExpert(this.state.expertData)
  setTimeout(()=>{
    this.handleTraiteSousRessourceCard(this.state.ressourceData,"TOUTES") 
    }, 3000);

 
}

handleShowAllEvent=(data)=>{
  var event=[]
  this.setState({evenements:event})
  try{

      data.map((element,idx) =>{
      var tab= {
        id: element.id,
        libelle: element.libelle,
        //thematique: element.nom,
        date:format(new Date(element.date_debut),'dd/MM/yyyy'),
        //format: element.format.code,
        heure: element.heure_debut,
        lieu: element.lieu,
        //typesystemeirrigue: element.nom,
        
        nombredevue : 
          <div
            data-toggle="tooltip" 
            data-placement="top" 
            data-html="true"
            title="Nombre de consultations de la ressource"
          >
            <span style={{backgroundColor:"#6A7172",color:"white"}} className="badge rounded-pill ">{element.nombre_vue}</span>
          </div>,

        nombredetelechargement : 
          <div
            data-toggle="tooltip" 
            data-placement="top" 
            data-html="true"
            title="Nombre de téléchargements de la ressource"
          >
            <span style={{backgroundColor:"#6A7172"}} className="badge rounded-pill ">{element.nombre_telecharge}</span>
          </div>,
        action: <span style={{backgroundColor:"#5FC4E1"}} className="badge rounded-pill"> <a onClick={this.handleDetailEvent.bind(this.bind,element.id)} >Consulter</a></span>,
        // action: <a > <i onClick={this.handleDetailEvent.bind(this.bind,element.id)} style={{color:"#5FC4E1"}} className="bx bxs-info-circle bx-sm   "/> </a>,
        
      }
     
      this.setState({evenements:[...this.state.evenements,tab]})
     
    })
  }catch(error){
console.log("errorrr")
  }

}

handleShowAllExpert=(data)=>{

  var event=[]
  this.setState({expert:event})

  data.map((element,idx) =>{
    var tab= {
      type: element.prenom?"Personne physique":"Personne morale",
      nom: element.prenom?element.nom+" "+element.prenom:element.nom,
      email: element.email,
      type_expert: element.type_expert?.libelle,
      //typesystemeirrigue: element.nom,
      action: <span style={{backgroundColor:"#5FC4E1"}} className="badge rounded-pill"> <a onClick={this.handleDetailExpert.bind(this.bind,element.id)} >Consulter</a></span>,
      // action: <a > <i onClick={this.handleDetailExpert.bind(this.bind,element.id)} style={{color:"#5FC4E1"}} className="bx bxs-info-circle bx-sm text-primary "/> </a>,
      
    }
   
    this.setState({expert:[...this.state.expert,tab]})
  })

}

handleTraiterEvent=()=>{
  var data=[]
  getEvenementBySearch(this.state.array_filter).then(data=>{
    this.handleShowAllEvent(_.uniqBy(data,'id'))
  })
  
  

}


handleTraiterExpert=()=>{
  var data=[]
  getExpertBySearch(this.state.array_filter).then(data=>{
    this.handleShowAllExpert(_.uniqBy(data,'id'))
  })
  

}


handleTraiterRechercher=()=>{
  

  getRessourceBySearch(this.state.array_filter).then(data=>{
    console.log("resssource search",data)
    var ressource=[]
    this.setState({type_ressource_card:"TOUTES"})
    _.uniqBy(data,'id').map((element,idx)=>{
      const description=element.description.substr(0,300)
     this.state.data_card[""+element.type_ressource.libelle].push(element)
     this.setState({data_card:this.state.data_card,card_exist:true})
     var tab= {
       nom: element.nom,
       //thematique: element.nom,
       description: element.description.length>=300?description+" ...":description,
       //format: element.format.code,
       //langue: element.nom,
       statut: element.statut,
       //typesystemeirrigue: element.nom,
       
       nombredevue : 
         <div
           data-toggle="tooltip" 
           data-placement="top" 
           data-html="true"
           title="Nombre de consultations de la ressource"
         >
           <span style={{backgroundColor:"#6A7172",color:"white"}} className="badge rounded-pill ">{element.nombre_vue}</span>
         </div>,
 
       nombredetelechargement : 
         <div
           data-toggle="tooltip" 
           data-placement="top" 
           data-html="true"
           title="Nombre de téléchargements de la ressource"
         >
           <span style={{backgroundColor:"#6A7172"}} className="badge rounded-pill ">{element.nombre_telecharge}</span>
         </div>,
       action: <span style={{backgroundColor:"#5FC4E1"}} className="badge rounded-pill"> <a onClick={this.handleDetail.bind(this.bind,element.id)} >Consulter</a></span>,
       // action: <a > <i onClick={this.handleDetail.bind(this.bind,element.id)} style={{color:"#5FC4E1"}} className="bx bxs-info-circle bx-sm"/> </a>,
       
     }
     ressource.push(tab)
     this.setState({ressource:ressource})
     if(idx==data.length-1){
       this.setState({recherche_card:true})
       $("#recherche").show()
       $("#data-recherche").hide()
     }
     
   })
   if(!data.length){
    this.setState({recherche_card:true,ressource})
    $("#recherche").show()
    $("#data-recherche").hide()
   }
 
  })
  
  this.handleInitDataCard()
  this.handleTraiterExpert()
  this.handleTraiterEvent()


  $("#recherche").hide()
  $("#data-recherche").show()

 // this.setState({ressource:result3})      
}

handlePushSousType=(data,element)=>{
  const card=this.state.data_sous_card
  const s_card={}
 data.map((val,idx)=>{
  this.setState({sous_card_exist:true})
    try{
      card[""+val.libelle].push(element)
      s_card[""+val.libelle]=""
      this.setState({data_sous_card:card,color_sous_card:s_card})
    }catch(error){
      card[""+val.libelle]=[]
      s_card[""+val.libelle]=""
      card[""+val.libelle].push(element)

      this.setState({data_sous_card:card,color_sous_card:s_card})
    } 
 }) 
}

handleTraiteRessourceCard=(unique,key)=>{
 const card=[]
 var ressource=[]
 this.setState({type_ressource_card:key,data_sous_card:{},type_sous_ressource_card:"",sous_card_exist:false})



 var index=0
  unique.map((element,idx)=>{

    if(element.sous_type_ressources.length){
      index+=1
    }

   this.handlePushSousType(element.sous_type_ressources,element)

   const description=element.description.substr(0,300)

    var tab= {
      nom: element.nom,
      //thematique: element.nom,
      description: element.description.length>=300?description+" ...":description,
      //format: element.format.code,
      //langue: element.nom,
      statut: element.statut,
      //typesystemeirrigue: element.nom,
      
      nombredevue : 
        <div
          data-toggle="tooltip" 
          data-placement="top" 
          data-html="true"
          title="Nombre de consultations de la ressource"
        >
          <span style={{backgroundColor:"#6A7172",color:"white"}} className="badge rounded-pill ">{element.nombre_vue}</span>
        </div>,

      nombredetelechargement : 
        <div
          data-toggle="tooltip" 
          data-placement="top" 
          data-html="true"
          title="Nombre de téléchargements de la ressource"
        >
          <span style={{backgroundColor:"#6A7172"}} className="badge rounded-pill ">{element.nombre_telecharge}</span>
        </div>,
      action: <span style={{backgroundColor:"#5FC4E1"}} className="badge rounded-pill"> <a onClick={this.handleDetail.bind(this.bind,element.id)}>Consulter</a></span>,
      // action: <a > <i onClick={this.handleDetail.bind(this.bind,element.id)} style={{color:"#5FC4E1"}} className="bx bxs-info-circle bx-sm"/> </a>,
      
    }
    ressource.push(tab)
   
    if(idx==unique.length-1){
  
  
        this.setState({recherche:true,block_card:null})
        this.setState({ressource:ressource,block_init_page:<div style={{marginTop:"250px",textAlign:"center"}}>
        <Spinner type="grow" color="secondary" /></div>})
        document.getElementById("ancre_1").click()
      
    }
    
  })

}

handleTraiteSousRessourceCard=(unique,key)=>{
  const card=[]
  var ressource=[]
  if(key==="TOUTES"){
    this.setState({type_ressource_card:key})
  }else{
    this.setState({type_sous_ressource_card:key})
  }
  

  var index=0
   unique.map((element,idx)=>{
 
    const description=element.description.substr(0,300)
    
      var tab= {
        nom: element.nom,
        //thematique: element.nom,
        description: element.description.length>=300?description+" ...":description,
        //format: element.format.code,
        //langue: element.nom,
        statut: element.statut,
        //typesystemeirrigue: element.nom,
        
        nombredevue : 
          <div
            data-toggle="tooltip" 
            data-placement="top" 
            data-html="true"
            title="Nombre de consultations de la ressource"
          >
            <span style={{backgroundColor:"#6A7172",color:"white"}} className="badge rounded-pill ">{element.nombre_vue}</span>
          </div>,

        nombredetelechargement : 
          <div
            data-toggle="tooltip" 
            data-placement="top" 
            data-html="true"
            title="Nombre de téléchargements de la ressource"
          >
            <span style={{backgroundColor:"#6A7172"}} className="badge rounded-pill ">{element.nombre_telecharge}</span>
          </div>,
        action: <span style={{backgroundColor:"#5FC4E1"}} className="badge rounded-pill"> <a onClick={this.handleDetail.bind(this.bind,element.id)}>Consulter</a></span>,
        //  action: <a > <i onClick={this.handleDetail.bind(this.bind,element.id)} style={{color:"#5FC4E1"}} className="bx bxs-info-circle bx-sm"/> </a>,
      }

    ressource.push(tab)
     
     if(idx==unique.length-1){
       
         this.setState({ressource:ressource})
         this.setState({recherche:true,block_card:null})
         document.getElementById("ancre_2").click()
       
       
     }
     
   })
 
 }

handleInitDataCard=()=>{
  Object.keys(this.state.data_card).map((el)=>{
    this.state.data_card[""+el]=[]
    this.setState({data_card:this.state.data_card})
  })
}


handleDateInterval= (date)=> {
 
  console.log("date",date)
  var data=[]
  this.setState({ressource_date:data})
  if(date.length==2){
    try{
      
      this.state.array_filter["date1"]=new Date(date[0])
      this.state.array_filter["date2"]=new Date(date[1])
      this.setState({array_filter:this.state.array_filter})
      
     }catch(ee){
       delete this.state.array_filter["date1"]
       delete this.state.array_filter["date2"]
       this.setState({array_filter:this.state.array_filter}) 
     }

    // this.setState({date_choose:true})
    // const NewDate1= date[0];
    // const NewDate2= date[1];
    // var tab= this.state.ressourceData.filter(dt=>(new Date(dt.date_edition))>=NewDate1 && (new Date(dt.date_edition))<=NewDate2)
    // this.setState({ressource_date:tab})
  }

  
}

  loading = () => <Spinner animation="grow" />

  
  render() {
    const { pick } = this.state

  
    const iconeList = [
      {
        id:1,
        url: "../../assets/images/icone-sis/autre.png",
        name: "autre"
      },
      {
        id:2,
        url: "../../assets/images/icone-sis/doc-cartographique.png",
        name: "doc-cartographique"
      },
      {
        id:3,
        url: "../../assets/images/icone-sis/documents-types.png",
        name: "documents-types"
      },
      {
        id:4,
        url: "../../assets/images/icone-sis/forum.png",
        name: "forum"
      },
      {
        id:5,
        url: "../../assets/images/icone-sis/manuel-et-guides.png",
        name: "manuel-et-guides"
      },
      {
        id:6,
        url: "../../assets/images/icone-sis/outils-de-calculs.png",
        name: "outils-de-calculs"
      },
      {
        id:7,
        url: "../../assets/images/icone-sis/rapports.png",
        name: "rapports"
      },
      {
        id:8,
        url: "../../assets/images/icone-sis/ressources.png",
        name: "ressources"
      }
    ]

    const data = {
      columns: [
        {
          label: "Titre",
          field: "nom",
          sort: "asc",
          width: 150,
        },
        {
          label: "Résumé",
          field: "description",
          sort: "asc",
          width: 100,
          // height: 10,
        },
        {
          label: <i style={{color:"#6A7172"}} className="fa fa-eye "></i>,
          field: "nombredevue",
          sort: "asc",
          width: 100,
        },
        {
          label: <i style={{color:"#6A7172"}} className="fa fa-download "></i>,
          field: "nombredetelechargement",
          sort: "asc",
          width: 100,
        },
        {
          label: "Fiche",
          field: "action",
          sort: "asc",
          width: 100,
        },
      ],
      rows:_.sortBy(this.state.ressource, 'created_at').reverse()
      
    }

    const dataEvenement = {
      columns: [
        {
          label: "Titre",
          field: "libelle",
          sort: "asc",
          width: 150,
        },
        {
          label: "Date",
          field: "date",
          sort: "asc",
          width: 270,
        },
        {
          label: "Heure",
          field: "heure",
          sort: "asc",
          width: 270,
        },
        {
          label: "Lieu",
          field: "lieu",
          sort: "asc",
          width: 100,
        },
        {
          label: "Détails",
          field: "action",
          sort: "asc",
          width: 100,
        },
      ],
      rows:_.sortBy(this.state.evenements, 'date_debut').reverse()
    }

    const dataExpert = {
      columns: [
        {
          label: "Type",
          field: "type",
          sort: "asc",
          width: 270,
        },
        {
          label: "Nom",
          field: "nom",
          sort: "asc",
          width: 150,
        },
        // {
        //   label: "Prénom",
        //   field: "prenom",
        //   sort: "asc",
        //   width: 270,
        // },
       
        {
          label: "Email",
          field: "email",
          sort: "asc",
          width: 270,
        },
        {
          label: "Type expert",
          field: "type_expert",
          sort: "asc",
          width: 270,
        },
        {
          label: "Détail",
          field: "action",
          sort: "asc",
          width: 100,
        },
      ],
       rows:_.sortBy(this.state.expert, 'created_at').reverse()
      //rows:this.state.expert
    }

    const animatedComponents = makeAnimated();

   
    

    return (
     
      <>
       <div id="block_page_acceuil"> 
       {/* <a style={{display:"block",marginTop:20}} href="#ancre_ressource" id="ancre_2">test</a> */}
      
     {
       (this.state.chargement)?
       (<>
        <div className="page-content">   {this.state.ok}
        <MetaTags>
            <title>Accueil | SIS</title>
            
          </MetaTags>
          <div className="container-fluid" >
            {/* <Breadcrumbs title="Accueil" breadcrumbItem="Accueil" /> */}

            {/* les liens des ancres */}
            <a style={{display:"none"}} href="#ressource" id="ancre_2"></a>

            <a style={{display:"none"}} href="#sous_type_ressource" id="ancre_1"></a>



            <div className="laRecherche">
              <Card style={{borderRadius:"65px",borderColor:"#032e87",borderWidth:"5px"}}>
              
                <CardBody>
                  <Row className="mt-2">
                    <Col lg="8" md="6" sm="12" className="mb-1">
                      <div className="form-outline">
                        <input
                          // type="text"
                          onChange={this.handleRechercheSimple}
                          type="search"
                          className="form-control"
                          placeholder={"Saisissez votre recherche"}
                          style={{borderRadius:"40px"}}
                        />
                      </div>
                    </Col>

                    <Col lg="4" md="6" sm="12" >
                      <div >
                        <button id="default-recherche" type="button" style={{backgroundColor:"#5FC4E1",float:"right",borderRadius:"40px"}} className="btn btn-info btn-elegant" onClick={this.handleDuBouttonRecherche}>
                          
                          <i className="fa fa-search pr-2" aria-hidden="true"></i> Recherche avancée
                        </button>

                      <Button variant="success"
                          disabled
                          id="charge-recherche-avance"
                          style={{borderColor:"#aad29a",float:"right",borderRadius:"10px",display:"none"}}
                        >
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Chargement ...
                      </Button>
                      
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
            <Row>

            {/* Présentation de SIS */}
            <Col lg="4" md="6" sm="12" className="mr-1">
               <img src={img_acceuil} style={{float:"left",borderRadius:"50px"}} class="rounded mx-auto d-block mr-1" width="310" height="210" alt="..."/>
            </Col>


            <Col lg="8" md="6" sm="12" className="ml-1">
              <p className="mb-2 ml-1" style={{textAlign:"justify",fontSize:"14px"}}>
               {this.state.sis_description}
              </p>
            </Col>
            </Row>
           
      

            <div className="leFiltre mt-3">
            <Card style={{borderRadius:"25px",borderColor:"#032e87",borderWidth:"5px"}}>
              <CardBody>
                <Row>
                  <Col className="col-2">
                    <label className="mt-3"><strong>FILTRE</strong></label>
                  </Col>
                  <Col className="col-10  float-right">
                    {/* <div className="f">
                      <button className="btn btn-info" onClick={this.handleDuBouttonFiltre}>Recherche simplifiée</button>
                    </div> */}
                    <div className="f">
                      <button type="button" style={{backgroundColor:"#5FC4E1",float:"right",borderRadius:"10px"}} className="btn btn-info btn-elegant" onClick={this.handleDuBouttonFiltre}>
                        <i className="fa fa-search pr-2" aria-hidden="true"></i> Recherche simplifiée
                      </button> 
                      {/* <button className="btn btn-success " onClick={this.handleDuBouttonRecherche}>Recherche avancée</button> */}
                    </div>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col md="4" lg="4">
                    <label>Thématique(s)</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceThematique}
                      options={this.state.thematique}
                      placeholder="Choisir le/les thématique(s)"
                    />
                  </Col>

                  <Col md="4">
                    <label>Format(s)</label> 
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceFormat}
                      options={this.state.format}
                      placeholder="Choisir le/les format(s)"
                    />
                  </Col>
                  
                  <Col md="4" lg="4">
                    <label>Intervalle de date d'édition</label>
                    <div className="docs-datepicker">
                      <InputGroup>
                        <Flatpickr
                          value={pick}
                          className="form-control d-block"
                          placeholder="Sélectionnez un intervalle de date d'édition"
                          options={{
                            locale:French,
                            mode: "range",
                            altInput: true,
                            // altFormat: "F j, Y",
                            dateFormat: "d-m-y"
                          }}
                          onChange={this.handleDateInterval}
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            className="btn btn-outline-secondary docs-datepicker-trigger"
                            disabled
                          >
                            <i
                              className="fa fa-calendar"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                      </InputGroup>
                      <div className="docs-datepicker-container" />
                    </div>
                  </Col>
                </Row>

                
                <Row className="mt-3">
                  <Col md="4" lg="4">
                    <label>Pays(s)</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceLocalisation}
                      options={this.state.localisation}
                      placeholder="Choisir le/les pays(s)"
                    />
                  </Col>
                  {
                    this.state.unite.length?
                  <Col md="4">
                    <label>Unité(s) administrative</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceUnite}
                      options={_.uniqBy(this.state.unite, 'label')}
                      placeholder="Choisir la/les unité(s) administrative"
                    />
                  </Col>:null
                   }

                  <Col md="4" lg="4">
                    <label>Langue(s)</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceLangue}
                      options={this.state.langue}
                      placeholder="Choisir la/les langue(s)"
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="4">
                    <label>Type(s) de système(s) d'irrigation</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceSysteme}
                      options={this.state.irrigue}
                      placeholder="Choisir le/les type(s) de système(s) d'irrigation"
                    />
                  </Col>
                  <Col md="4">
                    <label>Mot(s) clé</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                       onChange={this.handleFiltreAvanceMotCle}
                        options={this.state.motcle}
                      placeholder="Choisir le/les mot(s) clé"
                    />
                  </Col>
                  <Col md="4">
                    <label>Auteur(s)</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                       onChange={this.handleFiltreAvanceAuteur}
                        options={this.state.auteur}
                      placeholder="Choisir le/les auteur(s)"
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col md="6" lg="6">
                    <label>Type de ressource(s)</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceTypeRessource}
                      options={this.state.type_ressource}
                      placeholder="Choisir le/les type(s) de ressource(s)"
                    />
                  </Col>
                  {
                    this.state.sous_type_ressource.length?
                  <Col md="6" lg="6">
                    <label>Sous-type de ressource(s)</label>
                    <ReactSelect
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      isMulti
                      onChange={this.handleFiltreAvanceSousTypeRessource}
                      options={_.uniqBy(this.state.sous_type_ressource, 'label')}
                      placeholder="Choisir le/les sous-type(s) de ressource(s)"
                    />
                  </Col>:null
                  }
                </Row>

        

                <Row className="mt-4">
                  <Col md="9"></Col>
                  <Col md="3" >
                    <button
                      style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}
                      onClick={this.handleFiltreAvance} 
                      className="btn btn-success" 
                      id="recherche"
                    >
                      Chercher
                    </button>

                    <Button variant="success"
                      disabled
                      id="data-recherche"
                      style={{borderColor:"#aad29a",float:"right",borderRadius:"10px"}}
                     >
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                     Traitement ...
                   </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card> 
           
            </div>

            {/* <Row>
              <div className="f">
                <Col md="3">
                  
                </Col>
              </div>
            </Row> */}
            
            {/* Cartes */}
            
            {/* <hr/> */}

            <Row>
            {
                this.state.recherche_card?
              <>
              {/* <span className="text-center"> Sous-types de ressources</span> */}
              {
                this.state.card_exist?
                
                <h5 class="heading-1 text-center mt-3"><span>Types de ressources</span></h5>:(<div style={{textAlign:"center",marginBottom:10}}><span>Aucune Réssource trouvée !</span></div>)
                
              }
              
                {/* <Col lg="4" md="6" sm="12" className="mt-2">
                  <Card onClick={this.handleShowAllRessource}  className="block" id="block" style={{borderRadius:"25px",borderColor:"#032e87",borderWidth:"5px",backgroundColor:"FFFFF",backgroundColor:this.state.color_card["TOUTES"]}}>
                    <CardBody>
                      <CardTitle className="h4 mb-3">
                        <h3><span style={{backgroundColor:"#6A7172"}} className="badge rounded-pill ">TOUTES LES RESSOURCES</span></h3>
                      </CardTitle>
                      Nombre total de ressources : <span style={{backgroundColor:"#6A7172"}} className="badge rounded-pill ">{this.state.ressourceData.length}</span>
                      <div className="mt-3">
                        <button type="button" style={{backgroundColor:"#5FC4E1",float:"right",cursor:"pointer",borderRadius:"25px"}} className="btn btn-info btn-elegant" >
                          <i className="fas fa-eye mr-1"></i>
                        </button>
                      </div>
                    </CardBody>
                  </Card>
                </Col> */}
              
                {Object.keys(this.state.data_card).map((element,idx)=>(
                  (this.state.data_card[""+element].length)?
                    <Col lg="4" md="6" sm="12" className="mt-2" key={idx}>
                      <Card onClick={this.handleShowRessourceCard.bind(this,this.state.data_card[""+element],element)}  className="block" id="block" style={{borderRadius:"25px",borderColor:"#032e87",borderWidth:"5px",backgroundColor:this.state.color_card[""+element]}}>
                        <CardBody>
                          <CardTitle className="h4 mb-3">
                            <Col>
                              <h4 >
                                <span style={{backgroundColor:"#60c4e4"}} className="badge rounded-pill ">{this.state.data_card[""+element].length}</span>  <span style={{backgroundColor:"#6A7172"}} className="text-center badge rounded-pill ">{element}</span>
                                <img src={this.state.icons[""+element]} style={{float:"right"}} class="rounded mx-auto d-block" width="50" height="50" alt="..."/>
                              </h4>
                            </Col> 
                            {/* <Col><img src={this.state.icons[""+element]} style={{float:"right"}} class="rounded mx-auto d-block" width="50" height="50" alt="..."/></Col> */}
                            {/* <Col> <button type="button" style={{backgroundColor:"#5FC4E1",float:"right",cursor:"pointer",borderRadius:"20px"}} className="btn btn-info btn-elegant" > <i className="fas fa-eye mr-1"></i></button></Col> */}
                          </CardTitle>
                          {/* <img src={iconesis} class="rounded mx-auto d-block" width="60" height="60" alt="..."/> */}
                          {/* Nombre de ressources :  */}
                          {/* <h3><span style={{backgroundColor:"#60c4e4"}} className="badge rounded-pill ">{this.state.data_card[""+element].length}</span></h3> */}
                        </CardBody>
                      </Card>
                    </Col> : null
               ))}</>:this.state.block_card
              }
             
            </Row>


             {/* {
                this.state.sous_card_exist?
                <h5 class="heading-1 text-center"><span>Sous types de ressources</span></h5>:null
              } */}
 
            {/* Sous type de ressources */}
            <Row className="text-center justify-content-center">
            {Object.keys(this.state.data_sous_card).length?
              <>
              {/* <hr/> */}
              <h5 id="sous_type_ressource" class="heading-1 text-center"><span>Sous-types de ressources</span></h5>
              {Object.keys(this.state.data_sous_card).map((element,idx)=>(
            
              <Col lg="6" md="6" sm="12" className="mt-2" >
                <Card onClick={this.handleShowSousRessourceCard.bind(this,this.state.data_sous_card[""+element],element)}  className="block" id="block" style={{borderRadius:"70px",borderColor:"#032e87",borderWidth:"5px",backgroundColor:this.state.color_sous_card[""+element]}}>
                  <CardBody>
                   
                  <h5> <span style={{backgroundColor:"#60c4e4"}} className="badge rounded-pill ">{this.state.data_sous_card[""+element]?.length}</span>  <span style={{backgroundColor:"#6A7172"}} className="badge rounded-pill ">{element} </span>  </h5>
                    
                  </CardBody>
                </Card>
              </Col>
               ))}
              </>:null}
              <hr/>
            </Row>

          {
            this.state.recherche?
            <>  
            <Row id="ressource">
              <Col className="col-12 mt-2">
                <Card style={{borderRadius:"25px",borderColor:"#6A7172",borderWidth:"5px"}} >
                  <CardBody>
                    <CardTitle className="h4 mb-5">
                      <a onClick={this.handleShowAllRessource} style={{color:this.state.color_toute}} >LISTE DES RESSOURCES </a> <a>{"> "+this.state.type_ressource_card}</a> {this.state.type_sous_ressource_card!==""?<a>{"> "+this.state.type_sous_ressource_card}</a>:null}
                    </CardTitle>
                    <p className="card-title-desc"></p>
                     {
                      this.state.ressource.length?(<MDBDataTable responsive sortable={false} style={{textAlign:"justify"}} striped bordered entries="5" entrieslabel="5" entriesOptions={this.state.entriesLabelList} maxHeight="200px" searching={false} data={data} />):
                      (<span>Aucune Réssource trouvée !</span>)
                     }
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col className="col-12 mt-2">
                <Card style={{borderRadius:"25px",borderColor:"#6A7172",borderWidth:"5px"}}>
                  <CardBody>
                    <CardTitle className="h4 mb-5">
                      LISTE DES EVENEMENTS
                    </CardTitle>
                    <p className="card-title-desc"></p>
                    <div>
                    {
                        this.state.evenements.length?(<MDBDataTable responsive sortable={false} style={{textAlign:"justify"}} striped bordered entries="5" entrieslabel="5" entriesOptions={this.state.entriesLabelList} maxHeight="200px" searching={false} data={dataEvenement} />):
                        
                        (<span>Aucun évènement à venir !</span>)
                     }
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col className="col-12 mt-2">
                <Card style={{borderRadius:"25px",borderColor:"#6A7172",borderWidth:"5px"}}>
                  <CardBody>
                    <CardTitle className="h4 mb-5">
                      LISTE DES ACTEURS
                    </CardTitle>
                    <p className="card-title-desc"></p>
                    <div >
                    {
                      this.state.expert.length?(<MDBDataTable responsive sortable={false} style={{textAlign:"justify"}} striped bordered entries="5" entrieslabel="5" entriesOptions={this.state.entriesLabelList} maxHeight="200px" searching={false} data={dataExpert} />):
                      
                      (<span>Aucun acteur trouvé !</span>)
                    }
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            </>:this.state.block_ressource
          }
            {/* Block experts */}

            {/* <Row>
              <Col md="12" lg="12">
                <ExpertsCardAccueil/>
              </Col>
            </Row> */}


          </div>
        </div>
        </>):this.state.block_init_page
        
        
      }
      </div>
      <div id="block_detail_ressource">
         {
          this.state.show_detail?
          this.state.block_detail:null
         }
      </div>
      </>
      
    )
  }
}

// Dashboard.propTypes = {
//   t: PropTypes.any
// }

export default Acceuil
